const Content: React.FC = ({children}) => {
  return (
    <>
      {children}
    </>
  )
}

export {Content}
